import $ from 'jquery';
import StorageKeys from './utils/storage/StorageKeys';

const AbdetCookie = {
  initialize() {
    const { cltAnalyticsEnabled, analyticsBlockDetectionEnabled, environment } = window.AppSettings;

    const hasCookieConsent = window.AppState.hasAnalyticsConsent;

    // The Google Tag Gateway only runs on PRD (DAN-1487), matching the gate in the GTM tags,
    // so /clt/healthy is only probed there.
    if (
      cltAnalyticsEnabled &&
      environment === 'prd' &&
      analyticsBlockDetectionEnabled &&
      $.cookie(StorageKeys.COOKIE_ABDET) === undefined &&
      hasCookieConsent
    ) {
      AbdetCookie.checkAnalyticsEndpoint();
    }
  },

  checkAnalyticsEndpoint() {
    // First-party Google Tag Gateway health endpoint (DAN-1487). Any response counts as
    // "not blocked"; only a rejected request (e.g. an adblocker) marks analytics as blocked.
    // Credentials are omitted so the probe forwards no cookies to the gateway.
    const url = '/clt/healthy';

    fetch(url, { method: 'HEAD', credentials: 'omit' })
      .then(() => {
        $.cookie(StorageKeys.COOKIE_ABDET, false, { path: '/' });
      })
      .catch(() => {
        $.cookie(StorageKeys.COOKIE_ABDET, true, { path: '/' });
      });
  },
};

export default AbdetCookie;
